import React, { forwardRef, useImperativeHandle, useRef, useState } from "react"
import Api from "../../../../_helpers/Api"
import { trans } from "../../../../_providers/Translation"
import Subscription from "../list/Subscription"
import ActivateSubscription from "../list/ActivateSubscription"
import Question from "../../../modals/messages/Question"
import Success from "../../../modals/messages/Success"
import { Tab, Tabs } from "@mui/material"
import Servicing from "../list/Servicing"
import SubscriptionsList from "./SubscriptionsList"
import ServicingList from "./ServicingList"

function Index(props, ref) {
  const subscriptionModalRef = useRef(null)
  const activateSubscriptionModalRef = useRef(null)
  const deleteModalRef = useRef(null)
  const successModalRef = useRef(null)
  const servicingModalRef = useRef(null)

  const [activeTab, setActiveTab] = useState(1)
  const [refresh, setRefresh] = useState(0)

  useImperativeHandle(ref, () => ({}))

  const triggerRefresh = () => {
    setRefresh((prev) => prev + 1)
  }

  const handleEditSubscription = (id) => {
    subscriptionModalRef.current.open(id)
  }

  const handleDeleteSubscription = (id) => {
    let modal = deleteModalRef.current

    modal.open(id)

    modal.onSuccess(() => {
      handleDestroySubscription(id)
    })
  }

  const handleDestroySubscription = (id) => {
    Api.post("contractors/subscriptions/delete", { id }).then(() => {
      triggerRefresh()
    })
  }

  const handleActivateSubscription = (id) => {
    activateSubscriptionModalRef.current.open(id)
  }

  const handleRenewSubscription = (id) => {
    Api.post("contractors/subscriptions/renew", { id }).then(() => {
      successModalRef.current.open()
      triggerRefresh()
    })
  }

  const handleDeactivareSubscription = (id) => {
    Api.post("contractors/subscriptions/deactivate", { id }).then(() => {
      successModalRef.current.open()
      triggerRefresh()
    })
  }

  const handleEditServicing = (id) => {
    servicingModalRef.current.open(id)
  }

  const handleDeleteServicing = (id) => {
    let modal = deleteModalRef.current

    modal.open(id)

    modal.onSuccess(() => {
      handleDestroyServicing(id)
    })
  }

  const handleDestroyServicing = (id) => {
    Api.delete(`contractors/appliance-servicing/${id}`).then(() => {
      triggerRefresh()
    })
  }

  const handleAdd = () => {
    let modal = subscriptionModalRef.current
    if (modal) {
      modal.open()
      setActiveTab(1) // Switch to subscriptions tab
    }
  }

  const handleAddServicing = () => {
    let modal = servicingModalRef.current
    if (modal) {
      modal.open()
      setActiveTab(2) // Switch to servicing tab
    }
  }

  return (
    <div className="wrapper">
      <Subscription ref={subscriptionModalRef} onSave={triggerRefresh} />
      <Servicing ref={servicingModalRef} onSave={triggerRefresh} />

      <ActivateSubscription
        ref={activateSubscriptionModalRef}
        onSave={triggerRefresh}
      />

      <Question
        ref={deleteModalRef}
        mainMessage={trans("headings.confirmDelete")}
        secondaryMessage={trans("subheadings.confirmDelete")}
      />

      <Success ref={successModalRef} />

      <div className="top-part">
        <div className="left">
          <h1 className="page-heading">{trans('headings.subscriptions')}</h1>
          <p className="page-subheading">
            Lorem Ipsum е елементарен текст, използван в печатарската индустрия.
          </p>
        </div>
        <div
          className="right"
          style={{
            display: "flex",
          }}
        >
          <button className="button-add" onClick={handleAddServicing}>
            {trans('buttons.applianceServicing')}
          </button>
          <button
            className="button-add"
            onClick={handleAdd}
            style={{
              marginLeft: "8px",
            }}
          >
            {trans('labels.subscription')}
          </button>
        </div>
      </div>
      <Tabs
        value={activeTab}
        onChange={(e, newValue) => setActiveTab(newValue)}
        variant="scrollable"
        scrollButtons="auto"
        indicatorColor="primary"
        textColor="primary"
        aria-label="scrollable force tabs example"
      >
        <Tab value={1} label={trans('tabs.list')} />
        <Tab value={2} label={trans('tabs.forServicing')} />
      </Tabs>
      {activeTab === 1 && (
        <SubscriptionsList
          handleEdit={handleEditSubscription}
          handleDelete={handleDeleteSubscription}
          handleActivate={handleActivateSubscription}
          handleRenew={handleRenewSubscription}
          handleDeactivate={handleDeactivareSubscription}
          refresh={refresh}
        />
      )}
      {activeTab === 2 && (
        <ServicingList
          handleEdit={handleEditServicing}
          handleDelete={handleDeleteServicing}
          refresh={refresh}
        />
      )}
    </div>
  )
}

export default forwardRef(Index)
